<div id="top-el"></div>
<div class="wrapper wrapper__selfevaluation wrapper__selfevaluation--rating user-select-none"
     [ngStyle]="deviceInnerHeight > 0 ? {'height': deviceInnerHeight + 'px', 'min-height': 'auto'} : ''">
    <div class="row se-progress-bar" id="progress-bar">
        <div class="col-sm-12">
            <self-evaluation-progressbar-component *ngIf="totalFeelings"
                                                   [step]="currentStep"
                                                   [activePage]="(nextFeelingIndex + itemPerPage)" [total]="totalFeelings">
            </self-evaluation-progressbar-component>
        </div>
    </div>
    <div class="row mr-t--sm">
        <div class="col-sm-12 rating-area" [ngStyle]="maxRatingBar ? {'height': maxRatingBar + 'px'} : ''" [class.isIOS]="isIOS" (mouseup)="mouseUp($event)" (mousedown)="mouseDown($event)" (mousemove)="mouseMove($event)" (touchstart)="mouseDown($event)" (touchend)="mouseUp($event)" (touchmove)="mouseMove($event)">
            <p class="rating--title rating--title__heavy">
                <span class="rating--title__text rating--title__heavy--text">
                    {{ 'High Severity SE' | translate }}
                </span>
            </p>
            <p class="rating--title rating--title__mid hidden">
                <span class="rating--title__text rating--title__mid--text">
                    {{ 'Moderate Severity SE' | translate }}
                </span>
            </p>
            <p class="rating--title rating--title__low">
                <span class="rating--title__text rating--title__low--text">
                    {{ 'Low Severity SE' | translate }}
                </span>
            </p>

            <div class="rating-scale__top"></div>
            <div class="rating-scale" [style.z-index]="zIndex"></div>
            <div class="rating-scale__bottom"></div>

            <feeling-component *ngFor="let feeling of feelings" [feeling]="feeling" [isMobile]="isMobile" [scale]="symptomScaleOnMobile" [lang]="lang"></feeling-component>
        </div>
    </div>
    <div class="row wrapper__btns">
        <div class="col-xs-12 col-sm-5">
            <button type="button" class="btn badge-pill pd-v--sm btn-primary btn-xs-full" [ngClass]="(!nextIsAllowed || mouseEvent.nothing != 0) ? 'disabled' : ''" (click)="goToNext()">
                <i class="fas fa-angle-right fa-2x"></i>
                {{ 'Next' | translate }}
            </button>
            <button type="button" class="btn btn-secondary badge-pill pd-v--sm btn-xs-full" (click)="confirmModal.modal.show()">
                <i class="fas fa-clock"></i>
                {{ 'Continue later' | translate }}
            </button>
        </div>
    </div>
</div>

<self-evaluation-confirm-modal-component #confirmModal [isStudy] = "isStudy" [isIntroducePage]="false" (confirmContinueLater)="continueLater()"></self-evaluation-confirm-modal-component>
